import { render } from "./PagoSiroComponent.vue?vue&type=template&id=fb017c22&scoped=true"
import script from "./PagoSiroComponent.vue?vue&type=script&lang=js"
export * from "./PagoSiroComponent.vue?vue&type=script&lang=js"

import "./PagoSiroComponent.vue?vue&type=style&index=0&id=fb017c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb017c22"]])

export default __exports__